import { render, staticRenderFns } from "./GiftGoal.vue?vue&type=template&id=3de04f72"
import script from "./GiftGoal.vue?vue&type=script&lang=js"
export * from "./GiftGoal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports